import { ApiClientError, apiRequest } from './apiClient';
import {
  DocumentoDecisaoStatus,
  DocumentoValidacaoDetalhe,
  EvidenciaDocumentoDetalhe,
  EvidenciaTipo,
  EvidenciaUploadMetadata,
  EvidenciaUploadSession,
  OrgaoGestorDocumento,
} from '../types/documentosValidacao';

export function obterDocumentoValidacao(token: string, documentoId: string): Promise<DocumentoValidacaoDetalhe> {
  return apiRequest(`/documentos-oficiais/${documentoId}/validacao`, token);
}

export function listarOrgaosDocumento(token: string): Promise<OrgaoGestorDocumento[]> {
  return apiRequest('/orgaos-gestores', token);
}

export function registrarConsultaDocumento(token: string, documentoId: string, payload: {
  orgaoGestorId: string;
  tipoConsulta: string;
  criterioConsulta: string;
  valorConsultado: string;
  resultado: string;
  urlConsulta?: string;
  observacoes?: string;
}): Promise<unknown> {
  return apiRequest(`/documentos-oficiais/${documentoId}/consultas`, token, { method: 'POST', body: JSON.stringify(payload) });
}

export function solicitarUploadEvidencia(token: string, documentoId: string, metadata: EvidenciaUploadMetadata): Promise<EvidenciaUploadSession> {
  return apiRequest(`/documentos-oficiais/${documentoId}/evidencias/upload-sessions`, token, { method: 'POST', body: JSON.stringify(metadata) });
}

export async function enviarArquivoEvidencia(session: EvidenciaUploadSession, file: File): Promise<void> {
  let response: Response;
  try {
    response = await fetch(session.uploadUrl, { method: 'PUT', headers: session.uploadHeaders, body: file });
  } catch {
    throw new ApiClientError('STORAGE_INDISPONIVEL', 'Storage indisponível para receber a evidência.');
  }
  if (!response.ok) throw new ApiClientError('EVIDENCIA_UPLOAD_FALHOU', 'O storage não recebeu a evidência.', response.status);
}

export function confirmarUploadEvidencia(
  token: string,
  documentoId: string,
  payload: EvidenciaUploadMetadata & {
    uploadKey: string;
    consultaOrgaoGestorId?: string;
    tipoEvidencia: EvidenciaTipo;
    descricao: string;
    urlOrigem?: string;
  }
): Promise<EvidenciaDocumentoDetalhe> {
  return apiRequest(`/documentos-oficiais/${documentoId}/evidencias/confirm`, token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function decidirDocumento(
  token: string,
  documentoId: string,
  payload: { statusValidacao: DocumentoDecisaoStatus; evidenciaValidacaoId?: string; parecer?: string }
): Promise<unknown> {
  return apiRequest(`/documentos-oficiais/${documentoId}/validar`, token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function obterDownloadEvidencia(
  token: string,
  documentoId: string,
  evidenciaId: string
): Promise<{ url: string }> {
  return apiRequest(`/documentos-oficiais/${documentoId}/evidencias/${evidenciaId}/download`, token);
}

export async function sha256File(file: File): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
